var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInputSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66671 2.66634C4.45757 2.66634 2.66671 4.4572 2.66671 6.66634C2.66671 8.87548 4.45757 10.6663 6.66671 10.6663C8.87585 10.6663 10.6667 8.87548 10.6667 6.66634C10.6667 4.4572 8.87585 2.66634 6.66671 2.66634ZM1.33337 6.66634C1.33337 3.72082 3.72119 1.33301 6.66671 1.33301C9.61223 1.33301 12 3.72082 12 6.66634C12 9.61186 9.61223 11.9997 6.66671 11.9997C3.72119 11.9997 1.33337 9.61186 1.33337 6.66634Z",
    fill: "#334155"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.52864 9.52827C9.78899 9.26792 10.2111 9.26792 10.4714 9.52827L14.4714 13.5283C14.7318 13.7886 14.7318 14.2107 14.4714 14.4711C14.2111 14.7314 13.789 14.7314 13.5286 14.4711L9.52864 10.4711C9.26829 10.2107 9.26829 9.78862 9.52864 9.52827Z",
    fill: "#334155"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputSearchIcon);
export default __webpack_public_path__ + "static/media/inputSearchIcon.a64fadc00fab90473acdd6860b4a4b7c.svg";
export { ForwardRef as ReactComponent };